<template>
  <v-layout wrap justify-center class="pa-6">
    <v-flex xs12 md12>
      <v-card
        class="mx-auto col-12"
        max-width="1300"
        elevation="2"
        :disabled="load_card"
        :loading="load_card"
      >
        <v-card-title>
          <v-list-item>
            <v-list-item-icon>
              <v-icon size="30" color="blue darken-4 "
                >mdi-account-search-outline</v-icon
              >
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="headline">
                <v-row class="d-flex mb-4 justify-center" no-gutters>
                  <v-col class="d-flex mt-3" cols="4"
                    >Preconsulta Médica
                  </v-col>
                </v-row>
                <v-divider
                  class="mt-3"
                  :style="{ 'border-width': '1px', 'border-color': 'orange' }"
                />
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card-title>

        <div class="pa-0 px-8">
          <v-card-text class="px-0 pa-0">
            <v-row>
              <v-col class="d-flex" cols="3">
                <v-menu
                  v-model="pickerActual"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="fecha_actual"
                      label="Fecha Agenda"
                      append-icon="event"
                      hide-details
                      outlined
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fecha_actual"
                    @change="cargarAgendamiento()"
                    @input="pickerActual = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="d-flex" cols="8">
                <v-autocomplete
                  outlined
                  label="Médico"
                  :items="medicos"
                  :item-text="format_medico"
                  item-value="nro"
                  hide-details
                  v-model="form.medico"
                  return-object
                  clearable
                  @change="cargarAgendamiento()"
                  :error="errores.medico"
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-row class="d-flex mb-4 justify-center" no-gutters>
              <v-col class="mb-4" cols="6" sm="6">
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Buscar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <v-data-table
              v-if="agendaPaciente"
              :loading="load_table"
              :headers="headers"
              :items="agendaPaciente"
              item-key="nro"
              :search="search"
              class="elevation-1"
            >
              <template v-slot:item.btn_atencion="{ item }">
                <v-btn
                  color="indigo"
                  class="ma-2 white--text"
                  @click="abrir_historia(item)"
                  >{{ (text = "Preconsulta") }}</v-btn
                >
              </template>

              <!-- <template v-slot:item.btn_atender="{ item }">
                <v-btn
                  color="orange"
                  class="ma-2 white--text"
                  :disabled="item.nrohcl == 0"
                  @click="imprimir_hc(item, 1)"
                  >Imprimir</v-btn
                >
              </template> -->
              <template v-slot:item.id_paciente="{ item }">
                {{ item.id_paciente.trim().replace(/^0+/, "") }}
              </template>
            </v-data-table>
          </v-card-text>
        </div>
      </v-card>
    </v-flex>

    <v-dialog v-model="dialogo.estado" persistent max-width="1000px">
      <v-card class="mt-3 px-6">
        <v-toolbar class="mt-1 px-6" color="indigo">
          <span class="title col-12 white--text">{{ dialogo.titulo }}</span>
          <v-divider
            class="mt-6"
            :style="{ 'border-width': '1px', 'border-color': 'orange' }"
          />
        </v-toolbar>
        <v-card-text>
          <v-row class="mt-2">
            <v-col cols="12">
              <v-textarea
                label="Enfermedad Actual"
                outlined
                clearable
                hide-details
                v-model="form.enf_actual"
                auto-grow
                rows="1"
                row-height="10"
                :error="errores.enf_actual"
                @input="errores.enf_actual = false"
                @change="errores.enf_actual = false"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row class="d-flex justify-center">
            <v-col class="mt-4 d-flex" cols="2">
              <v-btn
                color="green"
                class="white--text mr-3"
                @click="guardar_preconsulta()"
                large
                depressed
              >
                Grabar
              </v-btn>
            </v-col>

            <v-col class="mt-4 d-flex" cols="2">
              <v-btn
                color="red"
                class="white--text mr-3"
                @click="dialogo.estado = false"
                large
                depressed
              >
                Cancelar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-row class="mb-3">
        <v-spacer></v-spacer>
      </v-row>
    </v-dialog>
  </v-layout>
</template>

<script>
import post from "../../methods.js";
var pdfMake = require("pdfmake/build/pdfmake.js");
var pdfFonts = require("pdfmake/build/vfs_fonts.js");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  components: {},
  data() {
    return {
      search: null,
      pickerActual: false,
      load_table: false,
      texto_descripcion: null,
      pickeFechaIni: false,

      idpaciente: 0,

      edadpaciente: "",
      epspaciente: "",
      sede: "0001",
      profesional: 0,

      medicos: [],
      datosagenda: [],
      agendaPaciente: [],

      disabled: {
        guardar_hc: true,
        imprimir_hc: true,
        sgte_paciente: true,
        salirsin_hc: false,
      },

      form: {},
      fechaag: null,
      horaag: null,
      consecutivo: 0,
      item_select: null,

      dialogo: {
        estado: false,
        titulo: null,
        paciente: null,
        tipo: null,
        item: {},
      },

      edad: {
        anos: 0,
        meses: 0,
        dias: 0,
      },

      fecha_actual: this.$moment().format("YYYY-MM-DD"),
      errores: {
        enf_actual: false,
      },
      headers: [
        {
          text: "Acción",
          align: "center",
          value: "btn_atencion",
          class: "indigo--text blue lighten-5",
        },

        {
          text: "Nro",
          align: "center",
          value: "nro",
          class: "indigo--text blue lighten-5",
        },
        {
          text: "Descripcion paciente",
          align: "center",
          value: "descrip_paciente",
          class: "indigo--text blue lighten-5",
        },
        {
          text: "Servicio",
          align: "center",
          value: "desc_servicio",
          class: "indigo--text blue lighten-5",
        },
        {
          text: "Fecha",
          align: "center",
          value: "fecha",
          class: "indigo--text blue lighten-5",
        },
        {
          text: "Hora",
          align: "center",
          value: "id_hora",
          class: "indigo--text blue lighten-5",
        },
        {
          text: "Identificacion paciente",
          align: "center",
          value: "id_paciente",
          class: "indigo--text blue lighten-5",
        },
        {
          text: "Entidad",
          align: "center",
          value: "contrato",
          class: "indigo--text blue lighten-5",
        },

        {
          text: "Estado",
          align: "center",
          value: "preconsulta_rep",
          class: "indigo--text blue lighten-5",
        },
      ],
      load_card: false,
    };
  },
  created() {
    this.get_empresa();
    this.get_profesionales();
  },
  methods: {
    get_empresa() {
      post
        .postData({
          url: "Financiero/dlls/CfEmpresaJ.dll",
          data: sessionStorage.Sesion + "|",
          method: "",
        })
        .then((data) => {
          this.datosEmpresa = data[0];
          this.form.espera = true;
          this.form.atendidos = false;
          this.form.todos = false;
        })
        .catch((err) => {
          this.$emit("snack", {
            color: "error",
            text: "Error al cargar Empresa",
            estado: true,
          });
        });
    },
    get_profesionales() {
      this.loader = true;
      let agencia = 0;
      let dll = "Clinico/dlls/CfAsistecJ.dll";
      post
        .postData({
          url: dll,
          data: sessionStorage.Sesion + "|" + agencia + "|",
          method: "",
        })
        .then((data) => {
          this.loader = false;
          this.medicos = JSON.parse(JSON.stringify(data));
        })
        .catch((err) => {
          this.loader = false;
          this.$emit("snack", {
            color: "error",
            text: "Error al cargar Profesionales",
            estado: true,
          });
        });
    },
    async guardar_preconsulta() {
      if (!this.form.enf_actual) {
        this.errores.enf_actual = true;
        this.send_error("Debe registrar la enfermedad actual !!");
      } else {
        var sesion = sessionStorage.Sesion;
        let fecha_ag = this.item_select.fecha;
        let hora_ag = this.item_select.id_hora.replace(/\:/g, "");
        let paciente = parseFloat(this.item_select.id_paciente);
        let profesional = this.form.medico.id;
        let plano = {};
        let index = 0;
        let cantidad_lineas = 0;
        let num = 0;
        let name = "";
        let end = 0;

        let enf_actual = this.form.enf_actual;
        let textoenf_actual = window.btoa(
          unescape(encodeURIComponent(enf_actual))
        );
        cantidad_lineas = Math.ceil(textoenf_actual.length / 900);

        for (let index = 0; index < cantidad_lineas; index++) {
          num = parseFloat(index + 1);
          name = `DATOJ_002-${String(num).padStart(3, "0")}`;
          end = parseFloat(parseFloat(index + 1) * 900);
          plano[name] = `${num}|${textoenf_actual.substring(end - 900, end)}`;
        }

        let datosEnvio =
          sesion +
          "|" +
          paciente +
          "|" +
          profesional +
          "|" +
          fecha_ag +
          "|" +
          hora_ag +
          "|";
        let data = {
          url: "Clinico/dlls/Preconsulta.dll",
          data: { importarhtml: datosEnvio, ...plano },
          method: "",
          json: true,
        };

        post.postData(data).then((response) => {
          this.$emit("snack", {
            color: "success",
            text: "Registro guardado correctamente",
            estado: true,
          });
          this.dialogo.estado = false;
          this.disabled.guardar_hc = true;
          this.disabled.imprimir_hc = false;
          this.clear_form;
          this.cargarAgendamiento();
        });
      }
    },
    abrir_historia(item) {
      this.item_select = item;
      this.dialogo.titulo =
        item.descrip_paciente.trim() +
        " Años:" +
        item.anosedad_rep.trim() +
        " Meses:" +
        item.mesesedad_rep.trim() +
        " Dias:" +
        item.diasedad_rep.trim();
      this.form.enf_actual = "";

      this.dialogo.estado = true;

      let base64String =
        item.base1_rep.trim() +
        item.base2_rep.trim() +
        item.base3_rep.trim() +
        item.base4_rep.trim() +
        item.base5_rep.trim() +
        item.base6_rep.trim() +
        item.base7_rep.trim() +
        item.base8_rep.trim() +
        item.base9_rep.trim() +
        item.base10_rep.trim() +
        item.base11_rep.trim() +
        item.base12_rep.trim() +
        item.base13_rep.trim() +
        item.base14_rep.trim() +
        item.base15_rep.trim() +
        item.base16_rep.trim() +
        item.base17_rep.trim() +
        item.base18_rep.trim() +
        item.base19_rep.trim() +
        item.base20_rep.trim() +
        item.base21_rep.trim() +
        item.base22_rep.trim() +
        item.base23_rep.trim() +
        item.base24_rep.trim() +
        item.base25_rep.trim() +
        item.base26_rep.trim() +
        item.base27_rep.trim() +
        item.base28_rep.trim() +
        item.base29_rep.trim() +
        item.base30_rep.trim() +
        item.base31_rep.trim() +
        item.base32_rep.trim() +
        item.base33_rep.trim() +
        item.base34_rep.trim() +
        item.base35_rep.trim() +
        item.base36_rep.trim() +
        item.base37_rep.trim() +
        item.base38_rep.trim() +
        item.base39_rep.trim() 

      let binaryData = atob(base64String);

      let byteArray = new Uint8Array(binaryData.length);
      for (let i = 0; i < binaryData.length; i++) {
        byteArray[i] = binaryData.charCodeAt(i);
      }
      let decoder = new TextDecoder("utf-8");
      let preconsulta = decoder.decode(byteArray);
      this.form.enf_actual = preconsulta;
    },

    cerrar_dialogo() {
      this.historia.estado = false;
      this.cargarAgendamiento();
      this.clear_form();
    },

    cargarAgendamiento: function (value) {
      this.load_table = true;
      this.loader = true;
      let profesional = parseFloat(this.form.medico.id);

      let datos =
        sessionStorage.Sesion +
        "|" +
        this.fecha_actual.split("-").join("") +
        "|" +
        profesional +
        "|" +
        1 +
        "|" +
        3 +
        "|";
      post
        .postData({
          url: "Clinico/dlls/Preconsulta01J.dll",
          data: datos,
          method: "",
        })
        .then((data) => {
          this.datosagenda = data;
          this.agendaPaciente = [];
          data.forEach((k, v) => {
            k.nro = (v + 1).toString().padStart(2, "0");
            if (k.identificacion) this.agendaPaciente.push(k);
          });
          this.load_table = false;
          this.loader = false;
        })
        .catch((err) => {
          this.loader = false;
          this.load_table = false;
          this.$emit("snack", {
            color: "error",
            text: "Error al cargar agendamiento",
            estado: true,
          });
        });
    },
    clear_form() {},
    format_medico(val) {
      return (
        parseFloat(val.id) + " - " + val.descripcion + " - " + val.descr_tipo
      );
    },
    send_error(msj) {
      this.$emit("snack", {
        color: "error",
        text: msj,
        estado: true,
      });
    },
  },
};
</script>
<style scoped>
.blanco {
  color: white;
}
</style>